import { render, staticRenderFns } from "./agreementPrice.vue?vue&type=template&id=3fdfbff6&scoped=true"
import script from "./agreementPrice.vue?vue&type=script&lang=js"
export * from "./agreementPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdfbff6",
  null
  
)

export default component.exports